/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Audits_SummaryInputs */



/**
* | output |
* | --- |
* | "Structured assessment of onboard, shore-side and terminal management systems against OCIMF frameworks, helping operators benchmark and improve." |
*
* @param {Service_Audits_SummaryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_audits_summary = /** @type {((inputs?: Service_Audits_SummaryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Audits_SummaryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("对照 OCIMF 框架，对船上、岸基和码头管理体系进行系统评估，帮助运营方对标和改进。")
	return /** @type {LocalizedString} */ ("Structured assessment of onboard, shore-side and terminal management systems against OCIMF frameworks, helping operators benchmark and improve.")
});